module.exports = "<p>\n  rkstest works!\n</p>\n"